import r from "./index410.js";
import { resolveComponent as i, createBlock as a, openBlock as o, resolveDynamicComponent as l, normalizeClass as d, withCtx as p, createElementVNode as m, createCommentVNode as n, createElementBlock as u, renderSlot as t } from "vue";
/* empty css         */
import c from "./index231.js";
const f = { class: "ms-button__flexWrapper" }, g = {
  key: 0,
  "aria-hidden": "true",
  class: "ms-button__icon"
};
function b(e, h, y, _, $, k) {
  const s = i("cs-button-loading-spinner");
  return o(), a(l(e.getTag()), {
    class: d(["ms-button", {
      "-inverted": e.isInverted,
      "-secondary": e.isSecondary,
      "-small": e.isSmall,
      "-noTextWrap": e.isTextNoWrap,
      "-square": e.isSquare,
      "-loading": e.isLoading
    }]),
    disabled: e.isDisabled,
    type: e.getType(),
    rel: e.getRel(),
    target: e.getTarget(),
    href: e.getHref(),
    "data-component": e.$options.name,
    "aria-label": e.getAriaLabel()
  }, {
    default: p(() => [
      m("span", f, [
        e.hasIcon() ? (o(), u("span", g, [
          t(e.$slots, "icon", {}, void 0, !0)
        ])) : n("", !0),
        t(e.$slots, "default", {}, void 0, !0)
      ]),
      e.isLoading ? (o(), a(s, {
        key: 0,
        class: "ms-button__loader",
        "aria-hidden": "true"
      })) : n("", !0)
    ]),
    _: 3
  }, 8, ["class", "disabled", "type", "rel", "target", "href", "data-component", "aria-label"]);
}
const S = /* @__PURE__ */ c(r, [["render", b], ["__scopeId", "data-v-0cd7eb0c"]]);
export {
  S as default
};
